import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchWaveformGenerationStatus,
  subscribeToWaveformGenerationStatus,
} from 'creators/shareVideo';

import { selectVideoWaveformStatus } from 'selectors/video';
import { selectVideoPlayerPassword } from 'selectors/videoPlayer';

import {
  WAVEFORM_FAILURE,
  WAVEFORM_SUCCESS,
} from '../../../../../shared/constants/video';

const FetchWaveform = () => {
  const dispatch = useDispatch();

  const [subscription, setSubscription] = useState();

  const videoPlayerPassword = useSelector(selectVideoPlayerPassword);
  const waveformGeneration = useSelector(selectVideoWaveformStatus);

  const inFinalStatus = [WAVEFORM_SUCCESS, WAVEFORM_FAILURE].includes(
    waveformGeneration
  );

  // Older videos or videos that will never have a waveform have a waveform
  // generation status of null.
  const waveformNotApplicable = waveformGeneration === null;

  // Subscribes and watches for waveform status changes
  useEffect(() => {
    if (waveformNotApplicable) {
      return;
    }

    if (!subscription) {
      if (inFinalStatus) {
        // If we haven't subscribed previously, we need to get the waveform
        // URL from GraphQL
        dispatch(fetchWaveformGenerationStatus(videoPlayerPassword));

        return;
      }

      console.log('waveform: Subscribing');

      const subscription = dispatch(
        subscribeToWaveformGenerationStatus(videoPlayerPassword)
      );

      if (subscription) {
        setSubscription(subscription);
      }
    }

    return () => {
      subscription?.unsubscribe();
    };
  }, [
    dispatch,
    subscription,
    inFinalStatus,
    videoPlayerPassword,
    waveformNotApplicable,
  ]);

  // makes sure we unsubscribe from pub/sub if we get a new waveform
  useEffect(() => {
    if (subscription && inFinalStatus) {
      console.log('waveform: Unsubscribing');

      subscription.unsubscribe();
      setSubscription(null);
    }
  }, [subscription, inFinalStatus]);

  return null;
};

export default FetchWaveform;
